var t = /* @__PURE__ */ ((i) => (i.Menu = "menu", i.Listbox = "listbox", i.Tree = "tree", i.Grid = "grid", i.Dialog = "dialog", i))(t || {});
const r = [
  "menu",
  "listbox",
  "tree",
  "grid",
  "dialog"
];
export {
  r as POPOVER_TYPES,
  t as PopoverType
};
